require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/core-js/modules/es6.array.species.js
// module id = ../../node_modules/core-js/modules/es6.array.species.js
// module chunks = 18